import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { ConnectionAuthKind } from 'shell-models-lib';
import { PowerBILinkedService } from 'app/model/linkedservice/powerbi.linkedservice';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { compact } from 'lodash';

export const powerBIMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: Metamodel.modelFor(PowerBILinkedService).name,
        displayName: stringResources.PowerBIConnection_DisplayText,
        icon: {
            className: 'svg-i_Semantic_Model_20x20'
        },
        supportedAuthKindsInTrident: compact([
            ConnectionAuthKind.OAuth2,
            ConnectionAuthKind.ServicePrincipal,
            ConnectionAuthKind.WorkspaceIdentity
        ]),
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'PowerBIDatasets' as ResourceKind
        },
        supportOPDG: true,
        category: ['Compute'],
        copySourceTypes: [],
        copySinkTypes: [],
        supportedInTrident: true,
        isCompute: true,
        isFirstClass: true,
        disableQueryAPI: true,
        supportFirstClassParameterExperience: true,
    };
    return metadata;
}
